import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';

import { Button } from '@mui/material';
import Async from 'components/Async';
import Form from 'components/Form';
import Modal, { IModalProps } from 'components/Modal';
import GrowTransition from 'components/Modal/animations/grow';
import store from 'store';

import { getMeetLessons } from '@common/api/meets';
import SelectField from '@common/components/Form/SelectField';
import TextField from '@common/components/Form/TextField';

import StyledAppointmentsBookingModalForm from './styled';

interface BookingFormValues {
	day: string;
	time: string;
	format: string;
	program: string;
	phone: string;
}

interface PropsType extends Omit<IModalProps, 'title' | 'onSubmit'> {
	initialValues: any;
	onSubmit: (data: BookingFormValues) => void;
	lesson: any;
}

function MeetModal({ initialValues, onSubmit, lesson, ...props }: PropsType) {
	const [loading, setLoading] = useState(true);
	const [programs, setPrograms] = useState([]);
	const lessons = [lesson];

	useEffect(() => {
		if (!props.open) {
			return;
		}
		const loadLessons = async (studentId: number, groupId: number) => {
			try {
				setLoading(true);
				const result = await getMeetLessons(studentId, groupId);
				setPrograms(
					result.programs.map((program: any) => ({
						label: program.program_name,
						value: program.program_id,
					})),
				);
			} finally {
				setLoading(false);
			}
		};
		loadLessons(store.profile.student?.id, store.profile.student?.groups[0].id);
	}, [props.open]);

	return (
		<Modal
			PaperProps={{
				sx: {
					maxWidth: '500px',
				},
			}}
			title="Booking"
			TransitionComponent={GrowTransition}
			transitionDuration={500}
			{...props}
		>
			<Form initialValues={initialValues} onSave={onSubmit} hideActions>
				{({ values }) => (
					<StyledAppointmentsBookingModalForm>
						<Async loading={loading}>
							<TextField name="day" disabled label="Day" />
							<TextField name="time" disabled label="Time" />
							<TextField name="phone" disabled label="Phone" />
							<TextField name="zoom_access_code" disabled label="Zoom Access Code" />
							<TextField name="zoom_id" disabled label="Zoom ID" />
							{values.zoom_link && (
								<a href={values.zoom_link} target="_blank" rel="noreferrer">
									{values.zoom_link}
								</a>
							)}
							{values.miro_link && (
								<a href={values.zoom_link} target="_blank" rel="noreferrer">
									{values.miro_link}
								</a>
							)}
							{values.type !== 'working_off' ? (
								<TextField name="comment_teacher" disabled label="Comment" />
							) : (
								<>
									<SelectField disabled label="Program" name="program" options={programs} />
									{values.program && lesson && (
										<SelectField
											disabled
											label="Lesson"
											name="lesson"
											options={lessons.map((lesson) => ({
												value: lesson.id,
												label: lesson.name,
											}))}
										/>
									)}
								</>
							)}
						</Async>
						<Button variant="contained" type="submit" color="error">
							Delete
						</Button>
					</StyledAppointmentsBookingModalForm>
				)}
			</Form>
		</Modal>
	);
}

export default observer(MeetModal);
